
export default
{
    path: "bill",
    meta: {
        title: "账单报表"
    },
    component: () => import("@/layouts/item"),
    children: [
        {
            path: "bill-list",
            component: () => import("@/pages/statistic/bill/bill-list"),
            meta: {
                title: "账单列表"
            }
        },
        {
            path: "bill-analysis-in",
            component: () => import("@/pages/statistic/bill/bill-analysis-in"),
            meta: {
                title: "收入分析报表"
            }
        },
        {
            path: "bill-analysis-out",
            component: () => import("@/pages/statistic/bill/bill-analysis-out"),
            meta: {
                title: "支出分析报表"
            }
        },


    ]
}

